module.exports = {"id":"171688","name":"Fábio Coentrão","rating":"79","photo":"./data/images/photos/2/171688.png","club":{"name":"Sporting CP","logo":"./data/images/clubs/SportingCP.png"},"positions":["DG","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabioCoentrao0.json
// module id = 1343
// module chunks = 0